import { useState } from 'react';

import { Box, Button, Dialog, Typography } from '@mui/material';

import { consentText } from './consentText';
const style = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  right: '50%',
  transform: 'translate(-50%, -50%)',
  width: 750,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

export const ConsentBanner = () => {
  const [open, setOpen] = useState(true);
  const handleClose = () => setOpen(false);

  return (
    <div>
      <Dialog open={open} fullScreen>
        <Box sx={style}>
          <Typography
            component='div'
            variant='body1'
            sx={{ fontWeight: 'bold' }}
          >
            {consentText}
          </Typography>
          <div style={{ justifyContent: 'center', display: 'flex' }}>
            <Button onClick={handleClose} variant='outlined'>
              I Agree
            </Button>
          </div>
        </Box>
      </Dialog>
    </div>
  );
};
